import React from 'react';

const Devices = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-10 -10 60 60">
    <path style={{ fill: 'none' }} d="M0 0h40v40H0V0z" />
    <circle style={{ fill: '#FFF' }} cx="23.1" cy="28.8" r="1" />
    <path
      style={{
        fill: 'none',
        stroke: '#FFF',
        strokeMiterlimit: 10,
      }}
      d="M7.5 23.8h18.1c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2H7.5c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2z"
    />
    <path
      style={{
        fill: 'none',
        stroke: '#FFF',
        strokeLinecap: 'round',
        strokeMiterlimit: 10,
      }}
      d="M9 23.8v-5m8.5 9.5v1m-4-1v1m-4-1v1"
    />
    <circle style={{ fill: '#FFF' }} cx="30" cy="22" r="1" />
    <path
      style={{
        fill: 'none',
        stroke: '#FFF',
        strokeMiterlimit: 10,
      }}
      d="M12.4 23.8V19c0-1.1.9-2 2-2h18.1c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-4.8"
    />
    <path
      style={{
        fill: 'none',
        stroke: '#FFF',
        strokeLinecap: 'round',
        strokeMiterlimit: 10,
      }}
      d="M15.9 17v-5m-4.5-4c2.2-2.5 6.1-2.7 8.6-.4.2.1.3.3.4.4m-7 2c1.4-1.3 3.6-1.3 5 0"
    />
  </svg>
);

export default Devices;
